import { tokenKey } from '../../assets/js/constants';

const INITIAL_STATE = {
    user: JSON.parse(localStorage.getItem(tokenKey)),
    validToken: false,
    userError: {},
}

export default function AuthReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'TOKEN_VALIDATED':
            if(action.payload) {
                return { ...state, validToken: true }
            } else {
                localStorage.removeItem(tokenKey)
                return { ...state, validToken: false, user: null }
            }
        case 'USER_LOGIN_FETCHED':
            localStorage.setItem(tokenKey, JSON.stringify(action.payload))
            return { ...state, user: action.payload, validToken: true }
        case 'USER_LOGOUT_COMPLETED':
            localStorage.removeItem(tokenKey)
            return { ...state, validToken: false, user: null }
        case 'USER_LOGIN_ERROR':
            return { ...state, userError: action.payload }
        default:
            return state
    }
}